import { FC, ReactNode } from 'react';
import { FormControl } from 'react-bootstrap';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import patterns from 'utils/patterns';

export interface EmailProps extends FormGroupProps {
    name?: string;
    disabled?: boolean;
    label?: ReactNode;
    placeholder?: string;
}

const $validators = {
    isError: () => true
};

const Email: FC<EmailProps> = ({
    name = 'email',
    disabled,
    label,
    placeholder = __('Email Address'),
    ...restProps
}) => {
    return (
        <FormGroup
            label={label}
            name={name}
            $validators={$validators}
            isError
            checker={value => {
                if (disabled) {
                    return true;
                }

                if (!value) {
                    return __('Please enter your email address');
                }

                if (!patterns.isUsEmail(value)) {
                    return __('Invalid e-mail address');
                }

                return true;
            }}
            {...restProps}>
            <FormControl disabled={disabled} placeholder={placeholder} />
        </FormGroup>
    );
};

export default Email;
